import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import SeleccionFraccion from './pages/SeleccionFraccion';
import PlanoInteractivo from './pages/PlanoInteractivo';
import SeleccionManzana from './pages/SeleccionManzana';
import SeleccionLote from './pages/SeleccionLote';
import BusquedaCliente from './pages/BusquedaCliente';
import RegistroCliente from './pages/RegistroCliente';
import RegistroVenta from './pages/RegistroVenta';
import MisReservas from './pages/MisReservas';
import Login from './pages/Login';

// Componente para rutas protegidas
function ProtectedRoutes() {
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user'));

    useEffect(() => {
        if (!user && window.location.pathname !== '/api/test2') {
            navigate('/login');
        }
    }, [user, navigate]);

    if (!user) return null;

    return (
        <div className="min-h-screen bg-gray-100">
            <nav className="bg-white shadow-lg">
				<div className="max-w-7xl mx-auto px-4">
					<div className="flex justify-between h-auto py-3">
						{/* Logo y título */}
						<div className="flex items-center space-x-4">
							<div className="flex flex-col">
								<h1 className="text-xl md:text-2xl font-bold text-gray-800 leading-tight">
									Inmobiliaria Montecristo
								</h1>
								<p className="text-xs md:text-sm text-gray-600">
									Reserva de Lotes
								</p>
							</div>
						</div>

						{/* Información del usuario y botón de cerrar sesión */}
						<div className="flex items-center">
							<div className="flex flex-col items-end mr-4">
								<span className="text-sm font-medium text-gray-800">
									{user.nombre_apellido_usuario}
								</span>
								<span className="text-xs text-gray-600">
									{user.cargo_usuario}
								</span>
							</div>
							<button 
								onClick={() => {
									localStorage.removeItem('user');
									navigate('/login');
								}}
								className="px-3 py-1 text-xs md:text-sm bg-[#2f62ab] text-white rounded hover:bg-red-700"
							>
								Cerrar Sesión
							</button>
						</div>
					</div>
				</div>
			</nav>

            <main className="py-10">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <Routes>
                        <Route path="/" element={<SeleccionFraccion />} />
                        <Route path="/plano/:fraccionId" element={<PlanoInteractivo />} />
                        <Route path="/manzanas/:fraccionId" element={<SeleccionManzana />} />
                        <Route path="/lotes/:manzanaId" element={<SeleccionLote />} />
                        <Route path="/buscar-cliente/:loteId" element={<BusquedaCliente />} />
                        <Route path="/registro-cliente/:loteId/:documento" element={<RegistroCliente />} />
                        <Route path="/venta/:loteId/:clienteId" element={<RegistroVenta />} />
                        <Route path="/mis-reservas" element={<MisReservas />} />
                    </Routes>
                </div>
            </main>
        </div>
    );
}

// Tu función App principal
function App() {
    return (
        <Router basename="/">
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/*" element={<ProtectedRoutes />} />
            </Routes>
        </Router>
    );
}

export default App;